import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function LastVisitedUrlTracker() {
  const location = useLocation();

  useEffect(() => {
    // Store the current URL to local storage or any other storage mechanism
    // if the location.pathname is not the OAuth callback URL
    const currentUrl = location.pathname + location.search;
    if (!currentUrl.startsWith('/dataops-oauth-callback')) {
      try {
        localStorage.setItem('lastVisitedUrl', currentUrl);
      } catch (e) {
        // Graceful degradation: user will be redirected to '/' after OAuth instead of last page
        console.warn('Could not save lastVisitedUrl to localStorage:', e);
      }
    }
  }, [location]);

  return null; // This component doesn't render anything
}
